import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import CustomArrows from "./Components/CustomArrows ";
import About from "./Components/About";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Product from "./Components/Product";
import AllProductModel from "./Components/AllProductModel";
import Contact from "./Components/Contact";
import Event from "./Components/Event";

import Footer from "./Components/Footer";
import ScrollToTopButton from "./Components/ScrollToTopButton";
import { useEffect } from "react";

function App() {
  useEffect(()=>{
    document.addEventListener('contextmenu', event => event.preventDefault())
    document.onkeydown = function(event) { 
      if(event.keyCode == 123) { 
      return false; 
      } 
      if(event.ctrlKey && event.shiftKey && event.keyCode == 'I'.charCodeAt(0)){ 
      return false; 
      } 
      if(event.ctrlKey && event.shiftKey && event.keyCode == 'J'.charCodeAt(0)){ 
      return false; 
      } 
      if(event.ctrlKey && event.keyCode == 'U'.charCodeAt(0)){ 
      return false; 
      } 
      } 
      
  },[])
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="CustomArrows" element={<CustomArrows />} />
        <Route path="About" element={<About />} />
        <Route path="Product" element={<Product />} />
        
        <Route path="/product/:id" element={<AllProductModel />} />
        <Route path="Contact" element={<Contact />} />
        <Route path="Event" element={<Event />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
      </Routes>

      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
